module.exports = __webpack_public_path__ + "img/ch.3b96ccfd.svg";